(function () {
  'use strict';
  var dialog = document.getElementById('SSSMysteryDiscount');
  if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  if (window.Shopify && window.Shopify.designMode) return;
  dialog.dataset.initialized = 'true';
  var formId = dialog.dataset.formId;
  if (!formId) return;

  var sessionKey = 'sss_mystery_session_v2';
  var dismissKey = 'sss_mystery_dismiss_until_v2';
  var subscribedKey = 'sss_mystery_subscribed_v2';
  var excludedKey = 'sss_offer_ab_excluded_v1';
  function getCookie(key) {
    try {
      var part = document.cookie.split(';').map(function (s) { return s.trim(); })
        .find(function (s) { return s.indexOf(key + '=') === 0; });
      return part ? part.slice(key.length + 1) : '';
    } catch (e) { return ''; }
  }
  function read(key, persistent) {
    var cookie = getCookie(key), stored = '';
    try { stored = (persistent ? localStorage : sessionStorage).getItem(key) || ''; } catch (e) {}
    if (cookie === 'seen' || stored === 'seen') return 'seen';
    return cookie || stored;
  }
  function write(key, value, maxAge) {
    try { (maxAge ? localStorage : sessionStorage).setItem(key, value); } catch (e) {}
    try { document.cookie = key + '=' + value + '; Path=/; SameSite=Lax' + (maxAge ? '; Max-Age=' + maxAge : '') + (location.protocol === 'https:' ? '; Secure' : ''); } catch (e) {}
  }
  var source = new URLSearchParams(location.search).get('utm_source') || '';
  if (source.toLowerCase() === 'omnisend') write(excludedKey, '1');
  if (read(excludedKey) === '1' || dialog.dataset.subscribed === 'true' || read(subscribedKey, true) === '1') return;
  if (Number(read(dismissKey, true)) > Date.now() || read(sessionKey) === 'seen') return;

  var arrival = Number(read(sessionKey));
  if (!arrival || arrival > Date.now()) {
    arrival = Date.now() - Math.min(performance.now(), 20000);
    write(sessionKey, String(arrival));
  }
  var boxes = Array.from(dialog.querySelectorAll('[data-sss-box]'));
  var status = dialog.querySelector('[data-sss-status]');
  var claim = dialog.querySelector('[data-sss-claim]');
  var activeForms = new Set();
  var chosen = false, finished = false, handoff = false, formViewed = false, submitted = false;
  var revealTimer, fallbackTimer, showTimer;
  var previousFocus;
  var analyticsQueue = [], analyticsTimer, analyticsAttempts = 0;
  var qa = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role !== 'main');
  try { qa = qa || sessionStorage.getItem('sss_offer_ab_qa_v1') === '1'; } catch (e) {}

  function flushAnalytics() {
    clearTimeout(analyticsTimer);
    if (!analyticsQueue.length) return;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    if (typeof window.gtag !== 'function') {
      if (++analyticsAttempts < 30) analyticsTimer = setTimeout(flushAnalytics, 1000);
      return;
    }
    while (analyticsQueue.length) {
      var name = analyticsQueue.shift();
      var params = { send_to: 'G-1E9BY64FS8', form_id: formId, design_version: 'fullscreen_v2' };
      if (qa) params.debug_mode = true;
      window.gtag('event', (qa ? 'sss_mystery_qa_' : 'sss_mystery_') + name, params);
    }
  }
  function record(name) {
    window.dispatchEvent(new CustomEvent('sss:mystery-offer', { detail: { event: name, form_id: formId } }));
    analyticsQueue.push(name);
    flushAnalytics();
  }
  document.addEventListener('visitorConsentCollected', flushAnalytics);
  function visible(el) {
    if (!el || el.closest('[hidden], details:not([open])')) return false;
    if (el.checkVisibility) return el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
    return !!(el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).opacity !== '0');
  }
  function anotherModalIsOpen() {
    if (activeForms.size) return true;
    return Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], #Q4Bogo.is-open, cart-drawer.active, .popup-modal--active, details[open].menu-drawer-container, #shopify-pc__banner')).some(function (el) {
      return el !== dialog && !dialog.contains(el) && visible(el);
    });
  }
  function hide(restoreFocus) {
    if (dialog.open) dialog.close();
    document.documentElement.classList.remove('sss-mystery-lock');
    if (restoreFocus && previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  }
  function show() {
    if (finished || read(sessionKey) === 'seen' || Number(read(dismissKey, true)) > Date.now()) return;
    if (document.visibilityState !== 'visible' || anotherModalIsOpen()) {
      showTimer = setTimeout(show, 1000);
      return;
    }
    previousFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('sss-mystery-lock');
    write(sessionKey, 'seen');
    record('view');
    dialog.focus({ preventScroll: true });
  }
  function dismiss() {
    finished = true; handoff = false;
    clearTimeout(revealTimer); clearTimeout(fallbackTimer); clearTimeout(showTimer);
    write(dismissKey, String(Date.now() + 86400000), 86400);
    hide(true);
  }
  function showFallback() {
    if (finished || !handoff) return;
    handoff = false;
    record('form_error');
    status.textContent = 'Your 18% OFF is saved. Tap below to try opening the signup form again.';
    claim.hidden = false;
    if (anotherModalIsOpen()) return;
    dialog.showModal();
    document.documentElement.classList.add('sss-mystery-lock');
    claim.focus({ preventScroll: true });
  }
  function openForm() {
    if (finished || handoff) return;
    handoff = true;
    hide(false);
    fallbackTimer = setTimeout(showFallback, 8000);
    try {
      window.omnisend = window.omnisend || [];
      // SDK processing overrides push; a plain, unprocessed queue must not accumulate retries.
      var rawQueue = Array.isArray(window.omnisend) && window.omnisend.push === Array.prototype.push;
      var queued = rawQueue && window.omnisend.some(function (c) { return Array.isArray(c) && c[0] === 'openForm' && c[1] === formId; });
      if (!queued) window.omnisend.push(['openForm', formId]);
    } catch (e) { clearTimeout(fallbackTimer); showFallback(); }
  }
  boxes.forEach(function (box) {
    box.addEventListener('click', function () {
      if (chosen || finished) return;
      chosen = true;
      record('box_reveal');
      boxes.forEach(function (item) { item.disabled = true; });
      box.classList.add('is-selected');
      dialog.classList.add('is-revealed');
      box.setAttribute('aria-label', '18% OFF unlocked');
      box.querySelector('.sss-mystery__pick').textContent = 'UNLOCKED';
      status.textContent = '18% OFF unlocked. Opening your signup form…';
      dialog.querySelector('[data-sss-close]').focus({ preventScroll: true });
      revealTimer = setTimeout(openForm, 1000);
    });
  });
  claim.addEventListener('click', openForm);
  dialog.querySelectorAll('[data-sss-close]').forEach(function (button) { button.addEventListener('click', dismiss); });
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); dismiss(); });
  window.addEventListener('omnisendForms', function (event) {
    var detail = event.detail || {}, form = detail.form || {};
    var name = detail.eventName || detail.type;
    if (form.displayType === 'popup' || form.displayType === 'flyout') {
      if (name === 'view') activeForms.add(form.id);
      if (name === 'close') activeForms.delete(form.id);
    }
    if (form.id !== formId || !chosen) return;
    if (name === 'view') {
      clearTimeout(fallbackTimer);
      finished = true; handoff = false;
      hide(false);
      if (!formViewed) { formViewed = true; record('form_view'); }
    }
    if (name === 'close') write(dismissKey, String(Date.now() + 86400000), 86400);
    if (name === 'submit' && !submitted) {
      submitted = true;
      write(subscribedKey, '1', 31536000);
      record('submit');
    }
  });
  window.addEventListener('pagehide', function () {
    clearTimeout(showTimer); clearTimeout(revealTimer); clearTimeout(fallbackTimer); clearTimeout(analyticsTimer);
    hide(false);
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && read(sessionKey) !== 'seen') {
      showTimer = setTimeout(show, Math.max(0, 20000 - (Date.now() - arrival)));
    }
  });
  showTimer = setTimeout(show, Math.max(0, 20000 - (Date.now() - arrival)));
})();
